<template>
    <div>
        <modaltutorialcategory v-model="dialog" :propAdd='paramProp' :val='val' />
        <modalconfirm ref="modalconfirmTutorialCategory" @action="deleteData" />
        <div class="d-flex justify-space-between">
            <div class="text-h5">Kategori E-Learning</div>
        </div>
        <v-card class="mt-3 mb-3" outlined>
            <v-list color="deep-purple lighten-5" dark class="pa-3">
                <v-list-item dense class="px-1">
                    <v-btn light depressed class="primary" @click="() => { dialog = true; paramProp = 'tambah'; val = {}; }">
                        <v-icon>mdi-plus-circle</v-icon>
                        <div class="pl-2 text-capitalize">Tambah Kategori</div>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
                        <v-icon>mdi-filter</v-icon>
                        <div class="pl-2 text-capitalize">Filter</div>
                    </v-btn>
                </v-list-item>
            </v-list>
        </v-card>
        <v-slide-y-transition>
            <v-card outlined class="mb-3" v-if="dropfilter">
                <filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
            </v-card>
        </v-slide-y-transition>
        <v-card outlined>
            <v-data-table loading disable-pagination :headers="headers" :items="tutorialCategoryResults" :search="search" hide-default-footer
                :options.sync="option" :server-items-length="tutorialCategoryPagination.total_data">
                <template v-slot:item.tutorial_category_name="{ item }">
                    <div class="pl-2 my-auto">{{ item.tutorial_category_name }}</div>
                </template>
                <template v-slot:item.tutorial_category_slug_name="{ item }">
                    <div class="pl-2 my-auto">{{ item.tutorial_category_slug_name }}</div>
                </template>
                <template v-slot:item.tutorial_category_color="{ item }">
                    <v-chip :color="item.tutorial_category_color" :text-color="fontColorbyBG(item.tutorial_category_color) ? '#FFFFFF' : '#000000'">{{ item.tutorial_category_name }}</v-chip>
                </template>
                <template v-slot:item.tutorial_category_status="{ item }">
                    <v-switch v-model="item.tutorial_category_status" @change="editStatus(item)"></v-switch>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="ubah(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
                                <v-icon dark>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click.stop="hapus(item.tutorial_category_id, item.tutorial_category_name)" class="" fab dark x-small
                                depressed color="pink" v-bind="attrs" v-on="on">
                                <v-icon dark>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Hapus</span>
                    </v-tooltip>
                </template>
                <template v-slot:progress>
                    <div> </div>
                </template>
                <template v-slot:loading>
                    <div class="py-3" v-if="!tutorialCategoryPagination">
                        <loading-data></loading-data>
                    </div>
                    <div class="py-3" v-else>
                        <not-found></not-found>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-5">
            <v-row v-if="tutorialCategoryPagination">
                <v-col cols="12" md="11" class="py-0 d-flex justify-end">
                    <v-pagination v-model="page" :length="tutorialCategoryPagination.total_page" @input="changePage" total-visible="7" circle
                        class="d-flex justify-end"></v-pagination>
                </v-col>
                <v-col cols="12" md="1" class="py-0 pl-0">
                    <v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" @input="changeLimit"
                        label="Item"></v-autocomplete>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import modaltutorialcategory from '@/views/MLwarehouse/tutorialCategory/ModalTutorialCategory'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
    inject: ['theme'],
    components: {
        modaltutorialcategory
    },
    data() {
        return {
            page: 1,
            limit: "10",
            listLimit: ['5', '10', '20', '50', '100'],
            propDelete: '',
            paramProp: '',
            paramDelid: '',
            paramDelName: '',
            val: {},
            edit: 'edit',
            dialog: false,
            dialogConfirm: false,
            dropfilter: false,
            search: '',
            headers: [
                { text: 'Nama Kategori', align: 'start', sortable: true, value: 'tutorial_category_name' },
                { text: 'Slug Kategori', value: 'tutorial_category_slug_name', sortable: false },
                { text: 'Warna Tag', value: 'tutorial_category_color', sortable: false },
                { text: 'Aktif', value: 'tutorial_category_status', sortable: false, },
                { text: 'Aksi', value: 'action', sortable: false, },
            ],
            filterData: [{
                type: 'text',
                label: 'Nama Kategori',
                filter: {
                    value: '',
                    comparison: 'like',
                    type: 'string',
                    field: 'tutorial_category_name'
                }
            }],
            params: [],
            paramStatus: {
                id: '',
                status: ''
            }
        }
    },
    props: {
        desserts: Array,
    },
    computed: {
        ...mapState('tutorialCategory', ['tutorialCategoryResults', 'responSukses', 'tutorialCategoryPagination', 'konfirmResponse']),
    },
    methods: {
        ...mapActions('tutorialCategory', ['getTutorialCategory', 'statusTutorialCategory', 'deleteTutorialCategory']),
        ...mapMutations('tutorialCategory', ['clearDataTutorialCategory']),
        ...mapMutations(['setOverlay', 'setFilter']),

        getData() {
            this.getTutorialCategory(this.queryString({ limit: this.limit, page: this.page, params: this.params, sort: this.sortBy, dir: this.sortDir }))
        },
        editStatus(stat) {
            this.paramStatus.id = stat.tutorial_category_id
            if (stat.tutorial_category_status == false) {
                this.paramStatus.status = '0'
            } else {
                this.paramStatus.status = '1'
            }
            this.statusTutorialCategory(this.paramStatus).then(() => {
                this.getData()
                this.paramStatus.id = ''
                this.paramStatus.status = ''
            })
        },
        hapus(id, name) {
            this.propDelete = id
            let msg = `Anda yakin ingin menghapus kategori ${name} ?`
            this.$refs.modalconfirmTutorialCategory.setMessage(msg)
            this.$refs.modalconfirmTutorialCategory.showConfirm()
        },
        async deleteData() {
            await this.setOverlay(true)
            await this.$refs.modalconfirmTutorialCategory.hideConfirm()
            await this.deleteTutorialCategory(this.propDelete).then(() => {
                if (this.responSukses.code == 200) {
                    this.getData()
                }
            })
            await this.setOverlay(false)
        },
        tambah() {
            this.dialog = true;
            this.paramProp = 'tambah';
            this.val = {};
        },
        ubah(item) {
            this.val = item;
            this.dialog = true;
            this.paramProp = 'edit';
        },
        changePage(page) {
            this.page = page
            this.getData()
        },
        changeLimit(limit) {
            this.limit = limit
            this.page = 1
            this.getData()
        },
        searchFilter(data) {
            this.params = data
            this.getData()
        },
        onResetFilter() {
            this.params = []
            this.getData()
        },
        fontColorbyBG(bgColor) {
            let color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
            let r = parseInt(color.substring(0, 2), 16); // hexToR
            let g = parseInt(color.substring(2, 4), 16); // hexToG
            let b = parseInt(color.substring(4, 6), 16); // hexToB
            return ((r * 0.299) + (g * 0.587) + (b * 0.114)) <= 186;
        }
    },
    created() {
        this.setFilter(this.filterData)
        this.getData()
        this.$store.dispatch('setPageTitle', `Kategori E-Learning`)
    },
    beforeDestroy() {
        this.clearDataTutorialCategory()
    },
    watch: {
        option(val, old) {
            this.sortBy = val.sortBy[0]
            this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
            this.page = 1
            if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
                this.getData()
            }
        }
    }
}
</script>

<style>
tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .05);
}

.v-avatar .avatar {
    object-position: center;
    object-fit: cover;
}
</style>